export default __webpack_public_path__ + "static/media/urban-launch-kit-small.e509b078.png";